export enum LockedProperties {
  sizeLocked = 'sizeLocked',
  quantityLocked = 'quantityLocked',
}
